<template>
  <div class="header" :class="{ [`bg-${type}`]: type }">
    <div class="container">
      <div class="header-body">
        <slot></slot>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'BaseHeader',
  props: {
    type: {
      type: String,
      default: 'gradient-header opacity-8',
      description: 'Header background type',
    },
  },
};
</script>
<style></style>
